import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { retry} from 'rxjs/operators';
import { Profesion } from '../models/profesion';

const OBTENER_API = environment.apiUrl + '/profesiones/obtener';

@Injectable({
  providedIn: 'root'
})
export class ProfesionalesService {

  constructor(protected http: HttpClient) { }

  obtener(): Observable<Profesion[]> {
    return this.http.get<Profesion[]>(OBTENER_API).pipe(
      retry(1)
    );
  }
}
